import Vue from 'vue';
import Vuex from 'vuex';

// plugin imports
import apiRouter from 'myra-ui-common/store/plugins/apiRouterPlugin';
import apiClient from 'myra-ui-common/store/plugins/apiClientPlugin';
import jwtPlugin from 'myra-ui-common/store/plugins/JWTPlugin';
import eventBus from 'myra-ui-common/store/plugins/EventBusPlugin';

// module imports
import common from 'myra-ui-common/store/modules/common';
import auth from 'myra-ui-common/store/modules/auth';
import agent from 'myra-ui-common/store/modules/agent';
import login from './modules/login';

Vue.use(Vuex);

export default new Vuex.Store({
    actions : {
        clearAll({ commit }) {
            commit('reset');
        },
    },
    modules : {
        common,
        auth,
        login,
        agent,
    },
    plugins : [apiRouter, apiClient, eventBus, jwtPlugin],
});
